export enum MessageStatus {
    Draft = 'Draft',
    Published = 'Published',
    Expired = 'Expired',
    Deleted = 'Deleted',
    WillPublish = 'WillPublish',
}
